import { render, staticRenderFns } from "./TileSettings.vue?vue&type=template&id=49a5bbdf&"
import script from "./TileSettings.vue?vue&type=script&lang=js&"
export * from "./TileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports